export const CANONICAL_COLORS = [
  'white',
  'black',
  'silver',
  'gray',
  'red',
  'blue',
  'green',
  'beige',
  'brown',
  'yellow',
  'orange',
  'gold',
  'other',
] as const;

export type CanonicalColor = typeof CANONICAL_COLORS[number];

export const CANONICAL_COLOR_HEX: Record<CanonicalColor, string> = {
  white: '#F5F5F5',
  black: '#1a1a1a',
  silver: '#C0C0C0',
  gray: '#6B7280',
  red: '#DC2626',
  blue: '#2563EB',
  green: '#16A34A',
  beige: '#E8D8B0',
  brown: '#78350F',
  yellow: '#EAB308',
  orange: '#EA580C',
  gold: '#D4AF37',
  other: '#9CA3AF',
};
